<template>
    <div class="third serviceOverviewBasicPage" >
        <div class="service-overview-header">服务概览</div>
        <div class="service-overview-content">
            <div class="service-block leftblock" v-if="serviceData">
                <div class="block-title">服务总数</div>
                <div class="block-content">
                    <div class="content-left">{{ serviceData.sumCount }}</div>
                    <div class="content-middle">
                        <div>
                            <service-number-echarts :dataInfo="serviceData"></service-number-echarts>
                        </div>
                    </div>
                    <div class="content-right">
                        <div class="right-clock" style="margin-bottom:20px;">
                            <div class="clock-name">已上架服务</div>
                            <div class="clock-num">{{ serviceData.upCount }}</div>
                        </div>
                        <div class="right-clock">
                            <div class="clock-name">已下架服务</div>
                            <div class="clock-num">{{ serviceData.downCount }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="service-block rightblock">
                <div class="block-title">服务使用率</div>
                <div class="block-content" style="min-height:280px;">
                    <div class="content-middle">
                        <el-progress class="progressClass" type="circle" :percentage="Number(serviceData.serviceRate.split('%')[0])" :stroke-width="15" :width="170"></el-progress>
                    </div>
                    <div class="prograssPointClass">
                        <div class="pointItem"><span class="point1"></span><span>服务总数</span></div>
                        <div class="pointItem"><span class="point2"></span><span>已上架</span></div>
                    </div>
                    <div class="content-right">
                        <div class="right-clock">
                            <div class="clock-name">已上架服务</div>
                            <div class="clock-num">{{ serviceData.upCount }}</div>
                        </div>
                        <div class="right-clock">
                            <div class="clock-name">服务总数</div>
                            <div class="clock-num">{{ serviceData.sumCount }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="service-overview-content">
            <div class="service-block leftblock2">
                <div class="block-title">
                    <div class="title-left">服务访问Top <span style="color:#3296FA;font-size:16px;">10</span></div>
                    <div class="title-right">
                        <el-tabs v-model="activeName" @tab-click="handleClick">
                            <el-tab-pane label="今日（实时）" name="1"></el-tab-pane>
                            <el-tab-pane label="本周" name="2"></el-tab-pane>
                            <el-tab-pane label="本月" name="3"></el-tab-pane>
                            <el-tab-pane label="本年" name="4"></el-tab-pane>
                        </el-tabs>
                    </div>
                </div>
                <div class="block-content" v-if="serviceTop.length > 0">
                    <service-fangwen-echarts :dataInfo="serviceTop"></service-fangwen-echarts>
                </div>
                <div class="block-content" v-else>
                    <div class="serviceTopContent">
                        <img class="serviceTopIMGClass" src="img/nonata_serviceTop.png" alt="">
                        <div class="nodata_serviceTop_tips">暂无数据</div>
                    </div>
                </div>
            </div>
            <div class="service-block rightblock2">
                <div class="block-title">角色访问服务分布</div>
                <div class="block-content" style="min-height:430px;" v-if="serviceData.roleTop.length > 0">
                    <div class="sorts-block">
                        <div class="sorts-block-item" v-for="item in serviceData.roleTop" :key="item.index" >
                            <div class="block-item-left">
                                <span class="roleSortClass" :class="[item.sort > 3 ? '' : 'topThree']">{{ item.sort }}</span>
                                {{ item.roleName }}
                            </div>
                            <div class="block-item-right">
                                <span class="roleNumberClass" v-if="item.count > 9999">9999+</span>
                                <span class="roleNumberClass" v-else>{{ item.count }}</span>
                                次</div>
                        </div>
                    </div>
                </div>
                <div class="block-content" style="min-height:430px;" v-else>
                    <div class="serviceTopContent">
                        <img class="roleTopIMGClass" src="img/nodata_roleTop.png" alt="">
                        <div class="nodata_serviceTop_tips">暂无数据</div>
                    </div>
                </div>
            </div>
        </div>
	</div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import { removeStore, setStore, getStore } from "@/utils/store";
export default {
	name: "serviceOverviewBasicPage",
	data() {
		return {
            activeName: '1',
            echartsLoading: false,
            serviceData: '',
            serviceTop: '',
		};
	},
	created() {
        this.getServicePreviewFuc()
        this.getServiceByTopFuc(1)
    },
	computed: {
		...mapState({
		    userInfo: state => state.user.userInfo
		})
	},
	methods: {
        ...mapMutations({
            changeComponentName: "SET_visitCountComponentName"
        }),
        ...mapActions([
            'getServicePreview',
            'getServiceByTop',
        ]),
        async getServicePreviewFuc() {
            this.tableLoading = true
            const {
                data: { result, msg, status }
            } = await this.getServicePreview()
            this.tableLoading = false
            if (status === 1000) {
                this.serviceData = result
                if (result.length !== 0) {
                    for (let i = 0; i < this.serviceData.roleTop.length; i++) {
                        this.serviceData.roleTop[i].sort = i + 1
                    }
                }
                return
            }
            this.$message.error(msg);
        },
        async getServiceByTopFuc(type) {
            this.tableLoading = true
            const {
                data: { result, msg, status }
            } = await this.getServiceByTop({
                type: type,
            })
            this.tableLoading = false
            if (status === 1000) {
                this.serviceTop = result
                return
            }
            this.$message.error(msg);
        },
        handleClick(tab, event) {
            this.getServiceByTopFuc(tab.name)
        }
	}
};
</script>
<style lang="scss">
.serviceOverviewBasicPage {
    min-height: 100vh;
    background-color: #FFF;
    font-family:PingFangSC-Medium,PingFang SC;
    .service-overview-header {
        padding: 15px;
        font-size: 16px;
        border-bottom: 1px solid #c4c4c42e;
    }
    .service-overview-content {
        padding: 15px 0px;
        text-align: center;
        .service-block {
            color: #2E4057;
            border-radius:2px;
            display: inline-block;
            vertical-align: top;
            box-shadow: rgba(239,239,244,1) 0px 4px 8px 2px;
        }
        .leftblock {
            width: 58%;
            margin: 0 1%;
        }
        .leftblock2 {
            width: 68%;
            margin: 0 1%;
        } 
        .rightblock {
            width: 35%;
            margin: 0 1%;
        }
        .rightblock2 {
            width: 25%;
            margin: 0 1%;
        }
        .block-title {
            font-size: 16px;
            padding: 15px;
            width: 100%;
            position: relative;
            text-align: initial;
            .title-left {
                width: 200px;
                // position: relative;
                // left: 0;
                display: inline-block;
                vertical-align: middle;
            }
            .title-right {
                position: absolute;
                right: 20px;
                display: inline-block;
                vertical-align: middle;
            }
        }
        .block-content {
            font-size: 16px;
            padding: 15px;
            width: 100%;
            text-align: center;
            .content-left {
                width: 30%;
                display: inline-block;
                font-size: 38px;
                color: #3296FA;
                vertical-align: middle;
            }
            .content-middle {
                width: 40%;
                display: inline-block;
                vertical-align: middle;
            }
            .content-right {
                width: 30%;
                display: inline-block;
                vertical-align: middle;
                .right-clock {
                    text-align: center;
                    line-height: 2;
                    .clock-name {
                        font-size: 14px;
                        color: #2E3F57;
                    }
                    .clock-num {
                        font-size: 18px;
                        color: #3296FA;
                    }
                }
            }
            .sorts-block {
                text-align: initial;
                .sorts-block-item {
                    // padding: 10px 0;
                    line-height: 2.7;
                    color: #2E3F57;
                    position: relative;
                    .block-item-left {
                        display: inline-block;
                        vertical-align: middle;
                        font-size: 14px;
                        .roleSortClass {
                            width: 14px;
                            height: 14px;
                            color: #FFF;
                            border-radius: 50%;
                            background-color: #C7C7CC;
                            display: inline-block;
                            vertical-align: middle;
                            margin-right: 10px;
                            line-height: 14px;
                            text-align: center;
                            font-size: 10px;
                        }
                        .topThree {
                            background-color: #3296FA!important;
                        }
                    }
                    .block-item-right {
                        display: inline-block;
                        vertical-align: middle;
                        font-size: 12px;
                        position: absolute;
                        right: 15px;
                        .roleNumberClass {
                            color: #2E3F57;
                            font-size: 17px;
                        }
                    }
                }
            }
            .serviceTopContent {
                height: 400px;
                text-align: center;
                .serviceTopIMGClass {
                    width: 180px;
                    height: 132px;
                    margin-top: 130px;
                }
                .roleTopIMGClass {
                    width: 108px;
                    height: 68px;
                    margin-top: 130px;
                }
                .nodata_serviceTop_tips {
                    margin-top: 5px;
                    font-size: 12px;
                    color: rgba(155, 155, 155, 1);
                }
            }
        }
    }
    .progressClass {
        display: inline-block;
        vertical-align: middle;
        .el-progress__text {
            font-size: 30px!important;
        }
    }
    .prograssPointClass {
        display: inline-block;
        vertical-align: middle;
        width: 100px;
        line-height: 2.5;
        margin-left: 15px;
        .pointItem {
            vertical-align: middle;
            text-align: left;
            font-size: 12px;
            color: #8C8C8C;
            .point1 {
                display: inline-block;
                width: 10px;
                height: 10px;
                border-radius: 50%;
                vertical-align: middle;
                background-color: #E5E9F2;
                margin-right: 8px;
            }
            .point2 {
                display: inline-block;
                width: 10px;
                height: 10px;
                border-radius: 50%;
                vertical-align: middle;
                background-color: #3296FA;
                margin-right: 8px;
            }
        }
    }
}
</style>
